import React from 'react';
import { Box, Text } from '@wix/design-system';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import { useHeroInsightBullets } from './useHeroInsightBullets';
const TOTAL_ROWS = 2;
export const INSIGHT_ROW_GAP = '9px';
export const HeroInsightBullets = _ref => {
  let domain = _ref.domain,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  const bullets = useHeroInsightBullets(domain, {
    totalRows: TOTAL_ROWS
  });
  const isSmall = size === 'small';
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isSmall ? '6px' : INSIGHT_ROW_GAP,
    width: "100%"
  }, bullets.map(bullet => /*#__PURE__*/React.createElement(Box, {
    key: bullet,
    direction: "horizontal",
    gap: isSmall ? '7px' : '10px',
    align: "left"
  }, /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "top",
    marginTop: isSmall ? '1px' : '3px'
  }, /*#__PURE__*/React.createElement(SparklesFilledSmall, null))), /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "thin",
    secondary: true
  }, bullet))));
};
//# sourceMappingURL=HeroInsightBullets.js.map